'use strict';
/* ==========================================================================
   levels/title.js — the title: a civic print shop poster (DESIGN.md §2).
   Parchment wall, red-white-blue paper bunting, the lesson name in ransom letters (two lines), the three buildings
   on their branch-coloured plinths with woodtype labels MAKES IT / RUNS IT / JUDGES IT (the song's hook), a wax seal,
   Rex (left) and Judge Okafor (right) rising in, ▶ Play → the map. On a phone held upright the controls move to the
   portrait dock (Dock.title) and the stage keeps only the art. Levels.title.loading() draws the "setting type…" screen
   while assets load (no textures yet: plain fills + ink only).
   Conventions (shared/engine/v2/README.md): draw through g, a pure function of time (T, this.enteredAt), sizes of
   tappable things through UI.button / UI.tap, no per-frame shadowOn() (core-local/civic.js pieces are cached).
   ========================================================================== */
(function () {
  const PLAY = { x: 960, y: 972 };
  const CV = () => window.Civic;
  // the title's ransom scraps in the civic palette (one constant array: the engine caches letters per palette object)
  const TITLE_PAL = [['#1f2f55', '#f3ead7'], ['#9e2b25', '#f3ead7'], ['#f3ead7', '#1f2f55'], ['#fffdf7', '#9e2b25'], ['news', '#2b2420'], ['#b08a2e', '#2b2420']];

  function titleLines(text) {
    const words = String(text).toUpperCase().split(/\s+/).filter(Boolean);
    if (words.length < 3 && text.length < 14) return [words.join(' ')];
    let best = null;
    for (let k = 1; k < words.length; k++) {
      const a = words.slice(0, k).join(' '), b = words.slice(k).join(' '), d = Math.abs(a.length - b.length);
      if (!best || d < best.d) best = { d, lines: [a, b] };
    }
    return best ? best.lines : [text.toUpperCase()];
  }
  const fitSize = (line, seed, maxW, max) => { const w = ransom(line, -5000, -5000, 100, 1e9, { seed, palette: TITLE_PAL }); return Math.min(max, (maxW / Math.max(1, w)) * 100); };

  const BUILDINGS = [
    { b: 'legislative', x: 660, rot: -0.02 },
    { b: 'executive', x: 960, rot: 0.015 },
    { b: 'judicial', x: 1260, rot: -0.012 },
  ];

  function backdrop(t0) {
    const Cv = CV();
    g.fillStyle = paperTile(Cv.C.parchment, 4); g.fillRect(0, 0, Game.W, Game.H);
    if (IMG.tex_paper) { g.save(); g.globalAlpha = 0.5; g.drawImage(IMG.tex_paper, 0, 0, Game.W, Game.H); g.restore(); }
    // the stage floor (kraft) and a torn newsprint scrap behind the title
    paperRect(960, 1040, 2000, 150, Cv.C.kraft, { seed: 21, torn: true, depth: 1, boil: false });
    texScrap('tex_news', 960, 300, 1240, 400, { rot: -0.012, seed: 22, depth: 1.1, tint: Cv.C.cream, tintAlpha: 0.35 });
    Cv.bunting(-20, 980, 18, { sag: 60, n: 11, seed: 2, t0: t0 + 0.1 });
    Cv.bunting(940, 1940, 18, { sag: 60, n: 11, seed: 3, t0: t0 + 0.25 });
  }

  class Title extends Scene {
    enter() { this.started = false; }
    go() {
      if (this.started) return;
      this.started = true;
      Audio.unlock();
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
      Game.replace(new Levels.map());
    }
    keyDown(k) { if (k === 'Enter' || k === ' ') this.go(); }

    draw() {
      UI.allLessons();                       // "← All lessons" (a paper tab; in the portrait dock a button in its bar)
      const t = this.t, t0 = this.enteredAt, L = Game.lesson || {}, Cv = CV();
      backdrop(t0);

      // title (ransom, civic scraps) + subtitle (hand) on the newsprint
      const lines = titleLines(L.title || 'NOBODY GETS ALL THE POWER');
      const sizes = lines.map((l, i) => fitSize(l, 211 + i, 1060, lines.length > 1 ? 112 : 132));
      let y = lines.length > 1 ? 196 : 250;
      lines.forEach((l, i) => { ransom(l, 960, y, sizes[i], t0 + 0.4 + i * 0.4, { seed: 211 + i, palette: TITLE_PAL }); y += sizes[i] * 1.3; });
      hand(L.subtitle || '', 960, y + 18, 58, t0 + 1.3, { dur: 0.5, color: Cv.C.navy, rot: -0.015 });
      Cv.seal(1545, 368, 58, { text: 'US', seed: 31, s: pop(T, t0 + 1.7, 0.3, 2.6), rot: 0.18 });

      // the three branches: building on a coloured plinth + a woodtype label
      BUILDINGS.forEach((B, i) => {
        const br = Cv.BRANCH[B.b], at = t0 + 0.7 + i * 0.18, s = pop(T, at, 0.4, 2);
        if (s <= 0) return;
        paperRect(B.x, 810, 250, 34, br.color, { seed: 60 + i, depth: 0.9, s, rot: B.rot });
        Cv.building(br.building, B.x, 796, 190, { s, rot: B.rot, seed: 70 + i });
        Cv.woodtype(br.short, B.x, 866, 34, { color: br.color, ink: br.ink, t0: at + 0.3, seed: 80 + i, rot: 0.02 });
      });

      // Rex (left) and the Judge (right) rise in from below
      const riseR = E.outBack(P(T, t0 + 0.5, t0 + 1.0), 1.4), riseJ = E.outBack(P(T, t0 + 0.7, t0 + 1.2), 1.4);
      Puppet.draw('rex', 250, 1080 + (1 - riseR) * 600, 700, { facing: 1, t: T });
      Puppet.draw('judge', 1690, 1080 + (1 - riseJ) * 600, 760, { facing: -1, t: T });

      // portrait phone: the controls are in the dock (core/dock.js Dock.title); the stage keeps only the art
      if (UI.docked()) { Dock.title({ onStart: () => this.go(), onContinue: () => this.go() }); return; }
      if (t > 1.4 && UI.button('play', '▶ Play', PLAY.x, PLAY.y, { w: 380, h: 116, color: Cv.C.brick, font: "'Luckiest Guy'", size: 64, rot: -0.015 })) this.go();
      if (t > 2.4) hand(UI.hint('(or press Enter)', 'tap ▶ Play to start'), PLAY.x + 330 + (UI.tap(116) - 116) / 2, PLAY.y + 6, UI.text(34), t0 + 2.4, { color: 'rgba(43,36,32,0.7)', seed: 61, align: 'left' });
    }
  }
  Title.PLAY = PLAY;                         // tools/integration.js clicks it

  /* loading screen: no textures yet → plain parchment, a composing stick setting type letter by letter */
  Title.loading = function () {
    g.fillStyle = '#efe2c2'; g.fillRect(0, 0, Game.W, Game.H);
    const word = 'SETTING TYPE', n = word.length, k = Math.floor((T * 6) % (n + 4));
    g.save(); g.font = "72px 'Alfa Slab One', Georgia, serif"; g.textAlign = 'center'; g.textBaseline = 'middle';
    const w = 74, x0 = 960 - (n * w) / 2 + w / 2;
    for (let i = 0; i < Math.min(k, n); i++) {
      if (word[i] === ' ') continue;
      g.fillStyle = '#1f2f55'; g.fillRect(x0 + i * w - 32, 440, 64, 84);
      g.fillStyle = '#f3ead7'; g.fillText(word[i], x0 + i * w, 486);
    }
    g.restore();
    ink([[560, 560], [1360, 560]], { w: 6, color: '#9e2b25', seed: 7, passes: 1, step: 40 });
    hand('printing the lesson…', 960, 650, 64, 0, { dur: 0.01, seed: 5, color: '#2b2420' });
  };

  Levels.title = Title;
})();
